import operator from './reducers';

export { default as operatorActions } from './actions';
export { default as operatorTypes }   from './types';

export default operator;
